<template>
  <section class="section">
    <h2> Campagnes </h2>
    <div class="mycard">
      <div
        v-if="(!isAdmin[0])"
        class="today-card"
      >
        <h3> Campagne en cours : </h3>
        <div class="today-card-widgets">
          <div class="today-progression-over">
            <div
              class="today-progressbar"
              :style="getProgressWidget()"
            >
              <b-field
                class="today-progression-content"
                :style="getColor(currentCampaignProgress)"
              >
                <div class="today-progresstext">
                  <span style="color: #FFF; font-weight: 800; font-size: medium;"><i class="fal fa-percent"></i> Progression</span>
                  {{ this.currentCampaignProgress }}%
                </div>
              </b-field>
            </div>
          </div>

          <div class="today-progression">
            <b-field
              class="today-podium-content"
              style="color: #2aa3d6;"
            >
              <span style="color: #FFF; font-weight: 800; font-size: large;"> <i class="fas fa-trophy"></i> Top Weezys<br></span>
              <span
                v-if="podiumFirst == 'N/A'"
                style="color: #FFF; font-weight: 2000; font-size: medium;"
              > {{ podiumFirst }} <br></span>
              <span
                v-if="podiumFirst != 'N/A'"
                style="color: #D4AF37; font-weight: 2000; font-size: medium;"
              > {{ podiumFirst }} <br></span>
              <span
                v-if="podiumSecond != ''"
                style="color: #9EA7B3; font-weight: 800; font-size: medium;"
              > {{ podiumSecond }} <br></span>
              <span
                v-if="podiumThird != ''"
                style="color: #8B4000; font-weight: 700; font-size: medium;"
              > {{ podiumThird }} <br></span>
            </b-field>
          </div>

          <div class="today-progression">
            <b-field
              class="today-other-content"
              style="color: #2aa3d6;"
            >
              <span style="color: #FFF; font-weight: 800; font-size: medium;"> <i class="fas fa-trophy"></i> Rang <br></span>
              <span
                v-if="rank == 1"
                style="color: #D4AF37; font-weight: 2000; font-size: xx-large;"
              > {{ rank }}er <br></span>
              <span
                v-if="rank == 2"
                style="color: #9EA7B3; font-weight: 2000; font-size: xx-large;"
              > {{ rank }}ème <br></span>
              <span
                v-if="rank == 3"
                style="color: #8B4000; font-weight: 2000; font-size: xx-large;"
              > {{ rank }}ème <br></span>
              <span
                v-if="!([1,2,3].includes(rank))"
                style="color: #FFF; font-weight: 2000; font-size: medium;"
              > {{ rank }}ème <br></span>
            </b-field>
          </div>

          <div class="today-progression">
            <b-field
              class="today-progression-content"
              style="color: #2aa3d6;"
            >
              <span style="color: #FFF; font-weight: 800; font-size: medium;"><i class="fas fa-analytics"></i> Ventes / Jour<br></span>
              {{ currentCampaignAverage }}
            </b-field>
          </div>

        </div>
        <div class="graph-container">
          <h3>Ventes de mon équipe :</h3>
          <div style="padding-top: 10px; padding-left: 20px;">
            <b-notification
              :closable="false"
              v-if="isLoading"
            >
              Chargement en cours ...
              <b-loading
                :is-full-page="isFullPage"
                :active.sync="isLoading"
                :can-cancel="true"
              ></b-loading>
            </b-notification>
          </div>
          <ve-histogram
            v-if="!isLoading"
            :data="chartData"
            :settings="chartSettings"
            :data-zoom="dataZoom"
          >
          </ve-histogram>
          <b-switch
            v-model="isLive"
            style="padding-left: 25px;"
            true-value="Direct"
            false-value="Pause"
          >
            {{ isLive }}
          </b-switch>
        </div>
      </div>
    </div>
    <div
      class="mycard"
      style="padding-bottom: 25px"
    >
      <div
        v-if="isAdmin[0]"
        class="past-card"
      >
        <h3> Toutes les Campagnes : </h3>
        <div class="past-card-widgets">
          <div class="campaign-selector-container">
            <div class="campaign-selector">
              <b-field label="Choisir la Campagne">
                <b-select
                  placeholder="Choisir la campagne"
                  v-model="campaignId"
                  :required="true"
                  @input="selectedCampaign()"
                >
                  <option
                    v-for="campaign in campaigns"
                    :key="campaign.id"
                    :value="campaign.id"
                  >{{campaign.name}}</option>
                </b-select>
              </b-field>
            </div>
          </div>
          <div class="campaigns">
            <div class="campaign-recap">
              <div class="recap-content">
                <div class="recap-line">
                  <b-field
                    class="recap-field"
                    label="Progression"
                    :style="getColor(selected)"
                  >
                    <div
                      id="myProgress"
                      style="width : 70%; height: 20px; background-color: #CCC;  border-radius: 20px; overflow: hidden"
                    >
                      <div
                        id="myBar"
                        :style="progressBarStyle"
                      >
                        {{ this.progressBarValue }}%
                      </div>
                    </div>
                  </b-field>

                  <b-field
                    class="recap-field"
                    label="Champion"
                  >
                    {{ this.campaignTopProducer }}
                  </b-field>

                  <b-field
                    class=""
                    label="Ventes / Jour"
                  >
                    {{ currentCampaignAverage }}
                  </b-field>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="isAdmin[0] && chartData.rows.length == 0"
          style="text-align: center; margin-left: 25px; margin-right: 25px; margin-top: 25px; "
        >
          Aucune information à afficher pour cette campagne.
        </div>
        <div
          v-if="isAdmin[0] && chartData.rows.length > 0"
          class="graph-container"
        >
          <h3>Ventes de toutes les équipes :</h3>
          <ve-histogram
            v-if="selected != null"
            :data="chartData"
            :settings="chartSettings"
            :data-zoom="dataZoom"
          >
          </ve-histogram>
          <div
            v-if="selected == null"
            style="text-align: center; width: 100%; padding-top: 25px;"
          >
            Choisissez une Campagne pour en voir le détail.
          </div>
          <div
            v-if="!hasCampaignGoals && selected != null"
            style="text-align: center; width: 100%; padding-top: 25px;"
          >
            Aucune donnée de vente disponible pour cete Campagne.
          </div>
          <b-switch
            v-if="selected != null"
            v-model="isLive"
            style="padding-left: 25px;"
            true-value="Direct"
            false-value="Pause"
          >
            {{ isLive }}
          </b-switch>

        </div>
      </div>
    </div>

  </section>
</template>

<script>
import "echarts/lib/component/dataZoom";
import VeHistogram from "v-charts/lib/histogram.common";
import VCharts from "v-charts";
import http from "@/modules/request";

export default {
  name: "dashboardCampaignsComponent",
  props: [
    "goals",
    "weezys",
    "campaigns",
    "users",
    "sales",
    "isAdmin",
    "ranking"
  ],
  components: { "ve-histogram": VeHistogram },

  data: () => {
    return {
      isEmpty: false,
      isLoading: true,
      myData: [],
      selected: undefined,
      campaignId: undefined,
      hasCampaignGoals: false,
      chartSettings: {
        metrics: ["Ventes"]
      },
      chartData: {
        columns: ["Date", "Ventes"],
        rows: []
      },
      dataZoom: [
        {
          type: "slider"
        }
      ],
      isLive: "Direct",
      currentCampaignProgress: "N/A",
      currentCampaignAverage: "N/A",
      currentCampaignChampions: [],
      progressBarValue: "N/A",
      progressBarStyle: "N/A",
      podiumFirst: "N/A",
      podiumSecond: "",
      podiumThird: "",
      rank: "N/A",
      allSales: [],
      campaignTopProducer: "N/A",
      isFullPage: false,
      storedSalesCount: 0
    };
  },
  watch: {
    campaigns: function(newVal, oldVal) {
      // watch it
      var sorted = JSON.parse(JSON.stringify(this.campaigns)).sort((a, b) =>
        a.start_date > b.start_date ? 1 : b.start_date < a.start_date ? -1 : 0
      );
      this.myData = sorted;
      if (this.campaignId == null && this.myData.length > 0) {
        this.campaignId = this.myData[0].id;
      }
      if (this.selected == null && this.myData.length > 0) {
        this.selected = this.myData[0];
      }

      if (this.selected != null) {
        for (var i = 0; i < this.weezys.length; i++) {
          if (this.weezys[i].campaign_id == this.selected.id) {
            for (var j = 0; j < this.goals.length; j++) {
              if (
                !this.goals[j].is_hidden &&
                this.goals[j].weezy_id == this.weezys[i].id
              ) {
                this.hasCampaignGoals = true;
                break;
              }
            }
          }
        }
      }
      this.updateGraph();
      this.getAverageSales(this.selected);
    },

    users: function(newVal, oldVal) {
      this.getTopProducer(this.selected);
    },
    ranking: function(newVal, oldVal) {
      // watch it
      if (this.podiumFirst == "N/A") {
        if (this.ranking.length > 0) {
          this.podiumFirst = "1. " + this.ranking[0].weezy_name;
        }
        if (this.ranking.length > 1) {
          this.podiumSecond = "2. " + this.ranking[1].weezy_name;
        }
        if (this.ranking.length > 2) {
          this.podiumThird = "3. " + this.ranking[2].weezy_name;
        }
        for (var i = 0; i < this.ranking.length; i++) {
          if (this.ranking[i].weezy_id == this.weezys[0].id) {
            this.rank = i + 1;
          }
        }
      }
    },
    sales: function(newVal, oldVal) {
      if (!this.isAdmin[0]) {
        this.updateGraph();
      }
    }
  },
  methods: {
    getProgressBarStyle(selected) {
      if (selected != undefined) {
        var value = this.progressBarValue;
        value = Math.min(value, 100);
        this.progressBarStyle =
          "width: " +
          value +
          "%; height: 20px; background-color: #4CAF50; text-align: center; line-height: 20px; color: white;  border-top-right-radius: 7px; border-bottom-right-radius: 7px;";
      }
    },
    updateGraph() {
      var campaign = undefined;
      if (this.isAdmin[0]) {
        if (this.selected) {
          campaign = this.selected.id;
        } else {
          return;
        }
      } else {
        if (this.weezys.length == 1) {
          campaign = this.weezys[0].campaign_id;
          this.$parent.getRanking(campaign);
          this.getMyCampaignProgress();
        }
      }

      var currentCampaignSales = [];
      var currentCampaignSalesPerGoal = [];
      var totalSales = 0;

      if ((this.isLive == "Direct" && campaign != undefined) || null) {
        // route to get sales of a campaign
        this.getCampaignSalesPerDate(campaign).then(res => {
          var tmpGoals = [];
          for (var goal of res) {
            goal.Date =
              this.leadZero(new Date(goal.Date).getDate()) +
              "/" +
              this.leadZero(new Date(goal.Date).getMonth() + 1) +
              "/" +
              new Date(goal.Date).getFullYear();
            tmpGoals.push(goal);
          }

          this.chartData.rows = tmpGoals;
          if (this.chartData.rows.length) {
            this.isLoading = false;
          }
        });
      }
    },
    getCampaignSalesPerDate(campaign_id) {
      return new Promise((resolve, reject) => {
        http
          .get(`/campaigns/${campaign_id}/salesperdate`)
          .then(res => {
            resolve(res.data);
          })
          .catch(error => {
            console.log(error);
            this.errored = true;
            if (error.response.status === 401) {
              console.log("unauthorized, logging out ...");
            }
            return Promise.reject(error.response);
          });
      });
    },

    selectedCampaign() {
      for (var i = 0; i < this.campaigns.length; i++) {
        if (this.campaignId == this.myData[i].id) {
          this.selected = this.myData[i];
          this.updateGraph();
          this.getCampaignProgress(this.selected);
          this.getProgressBarStyle(this.selected);
          this.getTopProducer(this.selected);
          this.getAverageSales(this.selected);
        }
      }
    },
    dateFormatter(value) {
      var date = new Date(value);
      var years = date.getFullYear();
      var months = this.leadZero(date.getMonth() + 1);
      var days = this.leadZero(date.getDate());
      return days + "-" + months + "-" + years;
    },
    leadZero(n) {
      return n > 9 ? n : "0" + n;
    },
    getCampaignName(FromWeezyId) {
      for (var i = 0; i < this.weezys.length; i++) {
        var weezy = this.weezys[i];
        if (weezy.id == FromWeezyId) {
          for (var j = 0; j < this.campaigns.length; j++) {
            if (weezy.campaign_id == this.campaigns[j].id) {
              return this.campaigns[j].name;
            }
          }
        }
      }
    },
    getWeezyName(fromWeezyId) {
      for (var i = 0; i < this.weezys.length; i++) {
        if (fromWeezyId == this.weezys[i].id) {
          return this.weezys[i].name;
        }
      }
    },
    getColor(row) {
      let percent = row;
      if (percent >= 100) {
        return "color: #0000BB;";
      } else if (percent >= 90) {
        return "color: #00AA00;";
      } else if (percent >= 70) {
        return "color: #66AA00;";
      } else if (percent >= 50) {
        return "color: #AAAA00;";
      } else if (percent >= 25) {
        return "color: #BB4400;";
      } else {
        return "color: #DD0000;";
      }
    },
    getVolume(value) {
      switch (value.toString()) {
        case "1":
          return "Min.";
        case "2":
          return "Moy";
        case "3":
          return "Max";
      }
    },
    getTopProducer(campaign) {
      if (campaign != undefined) {
        http
          .get(`/campaigns/${campaign.id}/topproducer`)
          .then(res => {
            this.campaignTopProducer = res.data;
          })
          .catch(error => {
            console.log(error);
            this.errored = true;
            if (error.response.status === 401) {
              console.log("unauthorized, logging out ...");
            }
            return Promise.reject(error.response);
          });
      }
    },

    getCampaignProgress(campaign) {
      if (campaign != undefined && campaign.id != 0) {
        // Clean in progress && campaign.weezys != undefined){
        this.progressBarValue = (
          (campaign.campaign_sales_done / campaign.campaign_sales_goal) *
          100
        ).toFixed(2);
      }
    },
    getMyCampaignProgress() {
      var campaign = null;
      for (var i = 0; i < this.campaigns.length; i++) {
        if (this.weezys[0].campaign_id == this.campaigns[i].id) {
          campaign = this.campaigns[i];
        }
      }
      if (campaign != null) {
        // Clean in progress && campaign.weezys != undefined){
        this.currentCampaignProgress = (
          (campaign.campaign_sales_done / campaign.campaign_sales_goal) *
          100
        ).toFixed(2);
      }
    },
    getAverageSales(campaign) {
      if (campaign != undefined) {
        http
          .get(`/campaigns/${campaign.id}/averagesales`)
          .then(res => {
            this.currentCampaignAverage = res.data.average;
          })
          .catch(error => {
            console.log(error);
            this.errored = true;
            if (error.response.status === 401) {
              console.log("unauthorized, logging out ...");
            }
          });
      }
    },

    getProgressWidget() {
      let value = this.currentCampaignProgress;
      var curve = 0;
      if (value > 60) {
        curve = 25;
      } else if (value > 35) {
        curve = 20;
      } else if (value > 25) {
        curve = 25;
      } else if (value > 15) {
        curve = 30;
      } else {
        curve = 40;
      }
      return (
        "height: " +
        (100 - value > 0 ? 100 - value : 0) +
        "%; border-bottom-left-radius: " +
        curve +
        "px; border-bottom-right-radius: " +
        curve +
        "px;"
      );
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* PHONE SIZE */
@media screen and (max-width: 768px) {
  .graph-container {
    display: none !important;
  }
}

.b-input-number {
  width: 59px;
}

.has-text-centered {
  max-width: 80%;
}

.modal-line {
  display: flex;
  justify-content: space-between;
}

.modal-input-field {
  width: 175px;
  padding-left: 0px;
}

.b-modal-input-number {
  width: 100px;
}

.b-modal-select-field {
  width: 200px;
}

.section {
  padding: 0%;
  display: grid;
}

h2 {
  font-size: 2em;
  color: rgb(42, 163, 214);
  height: 20px;
}

h3 {
  padding-top: 10px;
  padding-bottom: 20px;
  text-align: center;
  height: 15px;
  font-size: 1.5em;
  color: rgb(42, 163, 214);
}

.goals {
  display: inline-flex;
}

.campaign-recap {
  background-color: #2aa3d622;
  border-radius: 10px;
  max-width: 800px;
  min-width: 400px;
}

.campaign-selector-container {
  background-color: #2aa3d622;
  border-radius: 10px;
  padding: 10px;
  width: fit-content;
}

.recap-content {
  padding: 10px;
}

.recap-field {
  width: 150px;
  margin-bottom: 0px;
}

.recap-line {
  display: flex;
  justify-content: space-between;
}

.mycard {
  padding-top: 10px;
  padding-right: 20px;
  box-shadow: none;
}

.today-card {
  background-color: #2aa3d622;
  border-radius: 10px;
  padding-bottom: 10px;
}

.today-card-widgets {
  display: flex;
  justify-content: space-evenly;
  padding-bottom: 0px;
}

.past-card {
  background-color: #2aa3d622;
  border-radius: 10px;
  padding-bottom: 10px;
}

.past-card-widgets {
  display: flex;
  justify-content: space-evenly;
  padding-top: 10px;
  padding-left: 10px;
  padding-bottom: 10px;
}

.today-progression {
  background-color: #2aa3d666;
  width: 175px;
  height: 175px;
  border-radius: 50%;
}

.today-progression-over {
  background-color: #2aa3d666;
  width: 175px;
  height: 175px;
  border-radius: 50%;
  overflow: hidden;
}

.today-progression-content {
  text-align: center;
  height: 175px;
  width: 175px;
  display: table-cell;
  vertical-align: middle;
  font-weight: 700;
  font-size: 1.7em;
}

.today-progressbar {
  background-color: #00000044;
  width: 175px;
}

.today-other-content {
  text-align: center;
  padding-left: 2px;
  padding-right: 2px;
  height: 175px;
  width: 175px;
  display: table-cell;
  vertical-align: middle;
  font-weight: 700;
  font-size: 1.4em;
}

.today-podium-content {
  text-align: center;
  height: 175px;
  width: 175px;
  padding-left: 2px;
  padding-right: 2px;
  display: table-cell;
  vertical-align: middle;
  font-weight: 700;
  font-size: 1em;
}
</style>